// Граница ошибок над оболочкой (HQ-883): исключение рендера вне маршрутов (оболочка, панель вкладок, лист ярлыка) —
// экран ошибки с перезагрузкой, а не белый экран. Ошибки экранов ловит errorElement маршрутов (RouteError в App.tsx).
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { ErrorView } from './States';

interface State { error: unknown; failed: boolean }

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null, failed: false };

  static getDerivedStateFromError(error: unknown): State {
    return { error, failed: true };
  }

  override componentDidCatch(error: unknown, info: ErrorInfo): void {
    console.error(error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return <ErrorView error={this.state.error} onRetry={() => location.reload()} />;
  }
}
